import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input,
  Output,
} from '@angular/core';
import { DOCUMENT } from '@angular/common';
import {
  ITrackingAction,
  ITrackingObject,
} from '../../../tracking/tracking.data';

@Component({
  selector: 'app-copy-to-clipboard',
  templateUrl: 'copy-to-clipboard.component.html',
  styleUrls: ['copy-to-clipboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CopyToClipboardComponent {
  @Input() value: string;
  @Input() trackingObject: ITrackingObject;
  @Input() trackingAction: ITrackingAction;
  @Input() trackingAdditionalProperties: any;
  @Input() copyLinkCta: string;

  @Output() copy: EventEmitter<unknown> = new EventEmitter<unknown>();

  constructor(@Inject(DOCUMENT) private _document: Document) {}

  copyContent() {
    const copiedContent = this.value.replace(/<br\s*\/?>/gm, '\r\n');

    const contentTextArea = this._document.createElement('textarea');
    contentTextArea.style.position = 'fixed';
    contentTextArea.style.left = '0';
    contentTextArea.style.top = '0';
    contentTextArea.value = copiedContent;

    this._document.body.appendChild(contentTextArea);

    contentTextArea.focus();
    contentTextArea.select();
    this._document.execCommand('copy');

    this._document.body.removeChild(contentTextArea);

    this.copy.emit(copiedContent);
  }
}
